// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--3CziP","recruitment":"index-module--recruitment--7SnoS"};